import { gql } from '@apollo/client';

export const INTEGRATION_KEYS_QUERY = gql`
  query IntegrationKeys($first: Int, $after: String, $teamId: String) {
    integrationKeys(first: $first, after: $after, teamId: $teamId) {
      page {
        edges {
          node {
            _id
            name
            type
            data
            createdAt
            lastUpdatedDate
          }
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
        }
      }
      pageData {
        limit
        offset
      }
    }
  }
`;

export const UPDATE_INTEGRATION_KEY = gql`
  mutation UpdateIntegrationKey($payload: IntegrationKeyInput!, $teamId: String) {
    updateIntegrationKey(payload: $payload, teamId: $teamId) {
      _id
      name
      type
      data
      createdAt
      lastUpdatedDate
    }
  }
`;

export const DELETE_INTEGRATION_KEY = gql`
  mutation DeleteIntegrationKey($_id: String!, $teamId: String) {
    deleteIntegrationKey(_id: $_id, teamId: $teamId)
  }
`;
